import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { APP_BASE_HREF } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, Http, RequestOptions, JsonpModule } from '@angular/http';
import { AuthHttp, AuthConfig } from 'angular2-jwt';
import { AuthHttpWithRetry } from './services/http/auth-http-with-retry';
import { AgmCoreModule } from '@agm/core';
import { AppComponent } from './app.component';
import { AppConfig } from './app.config';
import { routing, appRoutingProviders } from './app.routing';
import { AuthService } from './services/auth/auth.service';
import { AuthTokenService } from './services/auth/auth-token.service';
import { UserService } from './services/user/user.service';
import { PageTitleService } from './services/pagetitle/pagetitle.service';
import { WidgetService } from './services/widget/widget.service';
import { PaymentsService } from './services/payments/payments.service';
import { WidgetTabOverrideService } from './services/widget/widget-tab-override.service';
import { WidgetLayoutService } from './services/widget/widget-layout.service';
import { Angulartics2Module } from 'angulartics2';
import { UrlBuilder } from './services/url/url.builder';
import { UserEvents } from './services/user/user.events';
import { VehicleRegistrationEvents } from './services/user/vehicle-registration.events';
import { NotificationService } from './services/notification/notification.service';
import { WillsEmailFormatterService } from './services/notification/willsemailformatter.service';
import { ProfileService } from './services/profile/profile.service';
import { WillsepalocalofficesService } from './services/willsEpaLocalOffices/willsepalocaloffices.service';
import { ComponentLookupService } from './services/widget/componentLookup.service';
import { AnalyticsService } from './services/analytics/analytics.service';
import { BroadcastService } from './services/broadcast/broadcast.service';
import { TmrService } from './services/user/tmr.service';
import { WindowRef } from './services/window-ref/window.ref';
import { DeleteVehicleRegistrationHandler } from './domain/vehicleRegistration/DeleteVehicleRegistrationHandler';
import { AddVehicleRegistrationHandler } from './domain/vehicleRegistration/AddVehicleRegistrationHandler';
import { FeatureToggles } from './shared/feature-toggles';
import { CommunityCentresService } from './services/communitycentres/communitycentres.service';
import { QldGovSearchService } from './services/qldgovsearch/qldgovsearch.service';
import { TokenInfoService } from './services/auth/token-info.service';
import { AccountMenuComponent } from './account-menu/account-menu.component';
import { MyDetailsEvents } from './mydetails/mydetails.events';
import { Angulartics2GoogleTagManager } from 'angulartics2/gtm';
import { PreFillService } from './widgets/templateDrivenWidget/pre-fill.service';
import { FileUploadService } from './widgets/templateDrivenWidget/proxyServices/file-upload.service';
import { ReminderService } from './reminder/service/reminder.service';
import { SafeDrivingService } from './widgets/templateDrivenWidget/services/safe-driving.service';
import {SirService} from './services/sir/sir.service';
import {KeycloakConfig} from './services/auth/keycloak-config';

export function authHttpServiceFactory(http: Http, options: RequestOptions, authTokenService: AuthTokenService, config: AppConfig) {
  return new AuthHttp(new AuthConfig({
    tokenGetter: (() => authTokenService.getToken()),
    globalHeaders: [{'Content-Type': 'application/json'}, {'x-api-key': config.getValue('mapApiKey')}]
  }), http, options);
}

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    routing,
    HttpModule,
    JsonpModule,
    ReactiveFormsModule,
    Angulartics2Module.forRoot([Angulartics2GoogleTagManager]),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDMv277YdHuxU-XxZ4EvWGUa5ZTrMrckZM'
    })
  ],

  declarations: [
    AppComponent,
    AccountMenuComponent
  ],
  providers: [
    MyDetailsEvents,
    appRoutingProviders,
    {
      provide: APP_BASE_HREF,
      useValue: '/'
    },
    {
      provide: AuthHttp,
      useFactory: authHttpServiceFactory,
      deps: [Http, RequestOptions, AuthTokenService, AppConfig]
    },
    AuthHttpWithRetry,
    {
      provide: APP_INITIALIZER,
      useFactory: AppConfig.app_initializer,
      deps: [AppConfig],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: KeycloakConfig.initializeKeycloak,
      multi: true,
      deps: [KeycloakConfig, Http],
    },
    AppConfig,
    AuthTokenService,
    KeycloakConfig,
    AuthService,
    FileUploadService,
    WidgetTabOverrideService,
    WidgetLayoutService,
    PageTitleService,
    UserService,
    WidgetService,
    PaymentsService,
    ComponentLookupService,
    UrlBuilder,
    UserEvents,
    VehicleRegistrationEvents,
    NotificationService,
    ProfileService,
    PreFillService,
    AnalyticsService,
    WillsEmailFormatterService,
    WillsepalocalofficesService,
    TmrService,
    ReminderService,
    WindowRef,
    BroadcastService,
    FeatureToggles,
    DeleteVehicleRegistrationHandler,
    AddVehicleRegistrationHandler,
    SafeDrivingService,
    CommunityCentresService,
    QldGovSearchService,
    TokenInfoService,
    SirService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./app/app.module.ts